import MaterialTable from 'material-table';
import { useNavigate } from 'react-router-dom';
import SendIcon from '../../../assets/send-icon.png';
import { useRef, useState } from "react";
import SendEmailNotification from './SendEmailNotification';
import tableIcons from '../../../utils/tableIcons';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Image, message } from 'antd';
import Loader from '../../shared/Loader';
import { GetServiceProviders, UpdateServiceProvider } from '../../../utils/api';
import IconShow from '../../../assets/show-icon_eyes.png';
import { imgPath } from '../../../utils/axiosInstance';
import Logo from '../../../assets/logo.png';

const Requested = () => {

    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [notificationDrawerData, setNotificationDrawerData] = useState({ visible: false, data: null });
    const [query, setQuery] = useState({
        page: 0,
        pageSize: 10,
        search: '',
        orderField: '',
        orderDirection: '',
    });
    const [btnLoading, setBtnLoading] = useState({ actionType: null });

    const columns = [
        {
            title: 'Id',
            field: 'id',
            sorting: true,
            cellStyle: { width: '6%' },
        },
        {
            title: 'Business Name',
            field: 'business_name',
            cellStyle: { width: '20%' },
            sorting: true,
            render: (record) => (
                <div className='flex items-center gap-x-3'>
                    <Image alt={record.business_name} src={record?.image ? `${imgPath}${record?.image}` : Logo} width={24} height={24} className='flex-shrink-0 rounded-full' />
                    <span className='cursor-pointer' onClick={(e) => handleNavigateToProfile(e, record)}>{record.business_name}</span>
                </div>
            ),
        },
        {
            title: 'Name',
            field: 'user_name',
            sorting: true,
            cellStyle: { width: '15%' },
        },
        {
            title: 'Location',
            field: 'business_location',
            sorting: false,
            cellStyle: { width: '29%' },
        },
        {
            title: 'Status',
            field: 'profileStage',
            sorting: false,
            cellStyle: { width: '12%' },
            render: (record) => <span className="text-[red] capitalize">{record.profileStage}</span>,
        },
        {
            title: 'Actions',
            sorting: false,
            cellStyle: { width: '18%' },
            align: 'center',
            render: (record) => (
                <div className='flex items-center justify-center gap-x-2 2xl:gap-x-3'>
                    <img alt='show-icon' src={IconShow} width={18} onClick={(e) => handleNavigateToProfile(e, record)} className='cursor-pointer' />
                    <button className="text-yellow-500 bg-yellow-100 border px-2 2xl:px-3 py-1 rounded-md font-medium text-[10px] 2xl:text-sm flex items-center" disabled={btnLoading[record.id]} onClick={() => changeProfileStage('approved', record?.id)}>
                        Approve
                        {btnLoading[record.id] && btnLoading.actionType === 'approved' && <span className='w-[13px] h-[13px] border-2 border-yellow-500 border-b-transparent box-border rounded-full ml-2 animate-spin'></span>}
                    </button>
                    <button className="text-[red] bg-red-100 border px-2 2xl:px-3 py-1 rounded-md font-medium text-[10px] 2xl:text-sm flex items-center" disabled={btnLoading[record.id]} onClick={() => changeProfileStage('rejected', record?.id)}>
                        Reject
                        {btnLoading[record.id] && btnLoading.actionType === 'rejected' && <span className='w-[13px] h-[13px] border-2 border-[red] border-b-transparent box-border rounded-full ml-2 animate-spin'></span>}
                    </button>
                    <img className='cursor-pointer' src={SendIcon} alt="send-icon" width={18} onClick={(e) => handleSendEmail(e, record)} />
                </div>
            ),
        },
    ];


    const handleNavigateToProfile = (e, record) => {
        e.stopPropagation();
        navigate(`/admin/service-providers/${record.id}`, { state: { type: 'requested' } });
    }


    const fetchData = async (dataquery) => {

        let params = 'profileStage=requested';

        if (dataquery?.search) {
            params += `&search=${dataquery.search}`;
        }

        if (dataquery?.orderBy) {
            params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
        }

        params += `&pageNo=${dataquery?.page + 1}`;

        params += `&limit=${dataquery?.pageSize}`;

        const response = await GetServiceProviders(params);

        return {
            data: response?.items,
            page: dataquery?.page,
            totalCount: response?.totalRecords
        };
    };


    const changeProfileStage = async (stage, id) => {
        try {
            setBtnLoading((prevStates) => ({
                ...prevStates,
                [id]: true,
                actionType: stage
            }));
            const res = await UpdateServiceProvider({ profileStage: stage }, id);
            setBtnLoading(false);
            if (res?.isSuccess) {
                message.success(stage === 'approved' ? 'Service Provider approved' : 'Service Provider rejected');
                tableRef.current.onQueryChange();
            }
        } catch (error) {
            setBtnLoading(false);
            message.error('Error in updating stage, Try again later');
        }
    }


    const handleSendEmail = (e, record) => {
        e.stopPropagation();
        setNotificationDrawerData({ visible: true, data: record });
    }



    const overlayContainer = {
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999,
    }


    return (
        <div className='searchposotion poppins'>

            <MaterialTable
                tableRef={tableRef}
                title="Clients"
                columns={columns}
                icons={tableIcons}
                page={query.page}
                options={{
                    showTitle: false,
                    draggable: false,
                    paging: true,
                    sorting: true,
                    search: true,
                    pageSize: query.pageSize,
                    pageSizeOptions: [10, 25, 50, 100],
                    debounceInterval: 700,
                    padding: 'desne',
                    paginationType: 'stepped',
                    searchFieldVariant: 'outlined',
                    searchFieldAlignment: 'left'
                }}
                // data={query => fetchData(query)}
                data={query => fetchData(query)}
                onChangeRowsPerPage={(pageSize => setQuery(prev => ({ ...prev, pageSize: Number(pageSize) })))}
                onChangePage={(page => setQuery(prev => ({ ...prev, page: Number(page) })))}
                components={{
                    Pagination: (props) => {
                        const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
                        return (
                            <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                                <div className='bottom-pagination-text'>
                                    <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                                    <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                                    <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1 || tableRef.current?.dataManager?.data?.length === 0}><RightOutlined /></button>
                                </div>
                                <div style={{ position: 'absolute', right: '25px' }} >
                                    <span style={{ margin: '0 10px' }}>Items per page:</span>
                                    <select disabled={tableRef.current?.dataManager?.data?.length === 0} className='pagination-select' value={rowsPerPage} onChange={(e) => {
                                        onChangeRowsPerPage(e, e.target.value);
                                    }}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        );
                    },
                    OverlayLoading: (props) => {
                        return (
                            <div style={overlayContainer}>
                                <Loader />
                            </div>
                        )
                    }
                }
                }
            />


            <SendEmailNotification notificationDrawerData={notificationDrawerData} setNotificationDrawerData={setNotificationDrawerData} />
        </div>
    )
}

export default Requested;